{
  "title": "ค้นหา",
  "input_label": "ค้นหาสินค้า ออเดอร์ ลูกค้า ผู้ฝากขาย หรือหน้าต่างๆ",
  "placeholder": "ชื่อการ์ด เลข cert รหัสสินค้า เลขออเดอร์ ชื่อลูกค้า…",
  "searching": "กำลังค้นหา…",
  "close": "ปิดการค้นหา",
  "results": "ผลการค้นหา",
  "source_error": "ค้นส่วนนี้ไม่ได้ — ลองอีกครั้ง",
  "nothing": "ไม่พบ “{{term}}”",
  "nothing_hint": "ตรวจการสะกด หรือสแกนเลข cert / รหัสสินค้าของการ์ด",
  "empty_hint": "พิมพ์ชื่อการ์ด เลข cert หรือเลขออเดอร์ — หรือสแกนบาร์โค้ด",
  "keys_hint": "↑ ↓ เลื่อน · Enter เปิด · Esc ปิด · ? ดูคีย์ลัด",
  "opens_new_tab": "เปิดในแท็บใหม่",
  "actions": {
    "add_card": "ลงการ์ด",
    "to_ship": "ออเดอร์ที่ต้องส่ง",
    "open_pos": "เปิด POS",
    "edit_home": "แก้หน้าแรก",
    "edit_menus": "แก้เมนูของเว็บ",
    "translate_missing": "แปลข้อความที่ยังว่าง",
    "translate_missing_count_other": "แปลข้อความที่ยังว่าง ({{count}})"
  },
  "groups": {
    "lookup": "ตรงทุกตัว",
    "actions": "ทำงาน",
    "products": "สินค้า",
    "orders": "ออเดอร์",
    "customers": "ลูกค้า",
    "consignors": "ผู้ฝากขาย",
    "pages": "หน้าในหลังบ้าน",
    "recent_opened": "เปิดล่าสุด",
    "recent_queries": "ค้นหาล่าสุด"
  },
  "shortcuts": {
    "title": "คีย์ลัด",
    "open_search": "ค้นหา",
    "new_product": "ลงการ์ด (ในหน้าสินค้า)",
    "go_orders": "ไปหน้าออเดอร์",
    "go_products": "ไปหน้าสินค้า",
    "show_shortcuts": "แสดงรายการนี้",
    "note": "คีย์ลัดไม่ทำงานขณะพิมพ์ในช่อง หรือขณะแป้นญี่ปุ่นกำลังเลือกตัวอักษร"
  }
}
